import { http } from '../config/config-receituario'

export default {
    listar: async (token, filters = {}) => {
        const config = {
            headers: {
                'Authorization': token
            },
            params: filters
        }
        try {
            return await http.get('lotes/filter', config)
        } catch (error) {
            if (error.response && error.response.status === 404) {
                return http.get('lotes', config)
            }
            throw error
        }
    },
    consultar: async (token, id) => {
        return http.get(`lotes/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    salvar: (token, lote) => {
        return http.post('lotes', lote, {
            headers: {
                'Authorization': token
            }
        })
    },
    update: (token, lote) => {
        return http.put(`lotes/${lote.id}`, lote, {
            headers: {
                'Authorization': token
            }
        })
    },
    deletar: (token, id) => {
        return http.delete(`lotes/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    }
}
